import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ManageProviderComponent } from '../provider/manage-provider/manage-provider.component';
import { GateProvidersListComponent } from '../provider/gate-providers-list/gate-providers-list.component';
import { PermissionsGuardService } from 'src/app/shared/services/permissions-guard.service';
import { AuthGuardService } from 'src/app/shared/services/auth.guard';
import { RouterModule, RoutesRecognized } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

const actionRoutes = [
  {
    path: '',
    component: GateProvidersListComponent,
    canActivate: [PermissionsGuardService, AuthGuardService]
  },
  {
    path: 'add',
    component: ManageProviderComponent,
    canActivate: [PermissionsGuardService]
  },
  {
    path: 'edit/:id',
    component: ManageProviderComponent,
    canActivate: [AuthGuardService]
  },
]
@NgModule({
  declarations: [
    GateProvidersListComponent,
    ManageProviderComponent,

  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(actionRoutes),
    ReactiveFormsModule
  ]
})
export class ProivderModule { }
